import React, { useState } from 'react';
import {
  Box, Button, ButtonGroup,
  Card,
  CardContent, Checkbox, FormControlLabel, FormGroup,
  Grid,
  TextField, Typography
} from '@material-ui/core';
import MultipleSelect from '../../general/MultipleSelect';
import moment from 'moment';
import DatePicker from '../../general/DatePicker';

const TableNavigationSearch = ({ loading, handleSubmit, clear }) => {
  const [id, setId] = useState('');
  const [authors, setAuthors] = useState('');
  const [title, setTitle] = useState('');
  const [publisher, setPublisher] = useState('');
  const [releaseDateStart, setReleaseDateStart] = useState(null);
  const [releaseDateEnd, setReleaseDateEnd] = useState(null);
  const [status, setStatus] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [amazon, setAmazon] = useState([]);
  const [meli, setMeli] = useState([]);
  const [onlyWantToRead, setOnlyWantToRead] = useState(false);
  const [onlyAlreadyRead, setOnlyAlreadyRead] = useState(false);

  const resetForm = () => {
    setId('');
    setTitle('');
    setAuthors('');
    setStatus([]);
    setReviews([]);
    setAmazon([]);
    setMeli([]);
    setPublisher('');
    setOnlyWantToRead(false);
    setOnlyAlreadyRead(false);
    setReleaseDateStart(null);
    setReleaseDateEnd(null);
    clear();
  };

  const onSubmit = () => {
    handleSubmit({
      id,
      authors,
      title,
      status,
      reviews,
      amazon,
      meli,
      onlyWantToRead,
      onlyAlreadyRead,
      publisher,
      releaseDateStart,
      releaseDateEnd
    });
  };

  return (
    <Card>
      <Box>
        <CardContent>
          <form onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}>
            <Grid container spacing={1} alignItems="center" justifyContent="space-between">
              <Grid item xs={3}>
                <Typography variant="h4">Pesquisar por:</Typography>
                <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                  <Grid item xs={6}>
                    <TextField
                      label="ID"
                      name="id"
                      type="text"
                      value={id}
                      onChange={e => setId(e.target.value)}
                      size="small"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Editora"
                      name="publisher"
                      type="text"
                      value={publisher}
                      onChange={e => setPublisher(e.target.value)}
                      size="small"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Autor"
                      name="authors"
                      type="text"
                      value={authors}
                      onChange={e => setAuthors(e.target.value)}
                      size="small"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Título"
                      name="title"
                      type="text"
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                      size="small"
                      margin="dense"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h4">Filtrar por:</Typography>
                <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                  <Grid item xs={4}>
                    <DatePicker label="Data de lançamento (início)"
                                fullWidth
                                value={releaseDateStart}
                                inputFormat="DD/MM/YYYY"
                                name="release_date_start"
                                onChange={(value) => {
                                  if (moment(value).isValid()) {
                                    setReleaseDateStart(value);
                                  }
                                }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MultipleSelect
                      label="Status de Infos G."
                      id="infoG"
                      value={status}
                      handleChange={v => setStatus(v)}
                      options={[
                        { value: 'filled', label: 'Preenchido' },
                        { value: 'old', label: 'Antigos' }
                      ]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MultipleSelect
                      label="Status de Seller - Amazon"
                      id="fLinks"
                      value={amazon}
                      handleChange={v => setAmazon(v)}
                      options={[
                        { value: 'no_links', label: 'Não disponível' },
                        { value: 'physical_digital', label: 'Físico e digital' },
                        { value: 'physical', label: 'Apenas físico' },
                        { value: 'digital', label: 'Apenas digital' },
                        { value: 'old', label: 'Antigos' }
                      ]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <DatePicker label="Data de lançamento (fim)"
                                value={releaseDateEnd}
                                inputFormat="DD/MM/YYYY"
                                name="release_date_end"
                                onChange={(value) => {
                                  if (moment(value).isValid()) {
                                    setReleaseDateEnd(value);
                                  }
                                }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MultipleSelect
                      label="Filtrar por status de Reviews"
                      id="fReviews"
                      value={reviews}
                      handleChange={v => setReviews(v)}
                      options={[
                        { value: 'no_review', label: 'Sem review' },
                        { value: 'filled', label: 'Preenchido' },
                        { value: 'old', label: 'Antigos' }
                      ]}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MultipleSelect
                      label="Status de Seller - Meli"
                      id="meliLinks"
                      value={meli}
                      handleChange={v => setMeli(v)}
                      options={[
                        { value: 'no_links', label: 'Não disponível' },
                        { value: 'physical', label: 'Apenas físico' },
                        { value: 'none', label: 'Não preenchido' }
                      ]}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h4">Mostrar apenas:</Typography>
                <Grid container spacing={1} alignItems="center" justifyContent="space-between">
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={onlyAlreadyRead}
                                    onChange={(e) => setOnlyAlreadyRead(e.target.checked)} />
                        } label="Livros adicionados à listas de lidos" />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={onlyWantToRead}
                                    onChange={(e) => setOnlyWantToRead(e.target.checked)} />
                        } label="Livros adicionados à listas para ler" />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <br />
            <Grid container>
              <Grid item xs={12} justifyContent="flex-end" display="flex">
                <ButtonGroup>
                  <Button
                    color="primary"
                    type="submit"
                    disabled={loading}
                    size="large"
                    variant="contained"
                  >
                    Pesquisar
                  </Button>
                  <Button
                    color="primary"
                    variant="outlined"
                    disabled={loading}
                    onClick={() => {
                      resetForm();
                    }}
                  >
                    Limpar
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Box>
    </Card>
  );
};

export default TableNavigationSearch;
